// extracted by mini-css-extract-plugin
export var noOverflowHidden = "_ba-0";
export var optionCard = "_ba-1";